<div class="editor-shell" [class.source-mode]="sourceMode">
  @if (!sourceMode) {
  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
  <ngx-editor [editor]="editor" [ngModel]="model" (ngModelChange)="onModelChange($event)" outputFormat="html" [placeholder]="placeholder"></ngx-editor>
  }
  @if (sourceMode) {
  <textarea [(ngModel)]="sourceCode" class="source-editor" aria-label="Código HTML"></textarea>
  }
  <div class="editor-actions">
    <button nz-button nzType="default" type="button" (click)="toggleSourceMode()">Código</button>
    <button nz-button nzType="default" type="button" (click)="openPreview()">Previsualizar</button>
    @for (key of confKeys; track key) {
    <button nz-button nzType="default" type="button" (click)="insertCampo(key)">{{ key }}</button>
    }
  </div>
</div>
<nz-modal [(nzVisible)]="previewVisible" (nzOnCancel)="handlePreviewCancel()" [nzClosable]="false" [nzFooter]="null">
  <ng-container *nzModalContent><div class="preview-box" [innerHTML]="previewHtml"></div></ng-container>
</nz-modal>
